<template>
  <header class="header">
    <!--<nav class="top-navigation">
      <router-link to="/" class="nav-link">홈</router-link>
      <router-link to="/whisper-test" class="nav-link">Whisper 테스트</router-link>
    </nav>-->
    <div class="header-content">

    
      <h1 class="title">Google x Dot Inc. x HYU</h1>
      <p class="subtitle"></p>

    </div>

  </header>
</template>

<script>
export default {
  name: 'HeaderComponent'
}
</script>

<style scoped>
.header {
  background: #FDF6E3;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.top-navigation {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 0.75rem 0;
  text-align: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.header-content {
  padding: 2rem 0;
  text-align: center;
}

.title {
  font-size: 4rem;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.subtitle {
  font-size: 1.2rem;
  color: #7f8c8d;
  font-weight: 300;
}

.nav-link {
  display: inline-block;
  margin: 0 1.5rem;
  padding: 0.6rem 1.5rem;
  text-decoration: none;
  color: white;
  border: 2px solid transparent;
  border-radius: 25px;
  transition: all 0.3s ease;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.nav-link.router-link-active {
  background: rgba(255, 255, 255, 0.9);
  color: #667eea;
  border-color: rgba(255, 255, 255, 0.3);
  font-weight: 600;
}

@media (max-width: 768px) {
  .title {
    font-size: 2rem;
  }
  
  .nav-link {
    margin: 0.25rem 0.5rem;
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }
  
  .top-navigation {
    padding: 0.5rem 0;
  }
  
  .header-content {
    padding: 1.5rem 0;
  }
}



.title {
  text-align: center;
  margin-top: 0.2rem;
}

.header-logo {
  height: 38px;
  object-fit: contain;
  opacity: 0.95;
  transition: transform 0.2s ease;
}

.header-logo:hover {
  transform: scale(1.05);
}
</style>
